<template>
  <!-- ヘッダーコンテンツ: お知らせ -->
  <div class="l-header-info">
    <a class="c-btn c-btn--square c-btn--info u-wh64" href="#info" @click="imageClick()">
      <div class="notification-badge"></div>
      <div class="c-icon u-wh28 c-icon--white c-icon--alpha70">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <use xlink:href="/assets/img/sprite.svg#notification" />
        </svg>
      </div>
    </a>
    <div class="l-header-info__list">
      <div class="c-balloon">
        <div class="c-balloon__arrow"></div>
        <div class="c-balloon__close" @click="closeClick()">
          <div class="c-icon u-wh22 c-icon--gray-3">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#close-thin" />
            </svg>
          </div>
        </div>
        <div class="c-balloon-title">
          <p class="c-balloon-title__label">お知らせ</p>
        </div>
        <ul v-if="headerData.news.length" class="c-balloon-list">
          <li v-for="(item, loopIndex1) in headerData.news" :key="loopIndex1" class="c-balloon-list__item">
            <dl :class="{'add-poiner': item.news_link}" @click="showLink(item)">
              <dt>{{ item.display_start_date }}</dt>
              <dd v-html="convertMarkdownToHtml(item.news_text)"></dd>
            </dl>
          </li>
        </ul>
        <ul v-else class="c-balloon-list">
          <li class="c-balloon-list__item">
            <dl>
              <dt></dt>
              <dd>お知らせはありません</dd>
            </dl>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import MarkdownIt from 'markdown-it';

export default {
  props: {
    headerData: Object,
  },
  emits: ["open"],
  data: function () {
    return {
      notifications: null,
      icon: null
    }
  },
  mounted: function () {
    this.notifications = $('.l-header-info__list');
    this.badge = $('.notification-badge');
    this.badge.hide();

    if (this.headerData.hasUnreadNews) {
      this.badge.show();
    }
  },
  methods: {
    updateViewDate: function () {
      axios
        .put("/api/system/check-news", {})
        .then((_res) => {
          this.badge.hide();
        })
        .catch((_error) => {
        });
    },
    showLink: function(item) {
      if (item.news_link) {
        window.open(item.news_link, "");
      }
    },
    isOpen: function(){
      return this.notifications.hasClass('is-active');
    },
    imageClick: function(){
      if (!this.isOpen()) {
        this.open();
      } else {
        this.close();
      }
    },
    closeClick: function(){
      this.close();
    },
    open: function(){
      if (!this.headerData.isSystemAdminEdit) {
        setTimeout(() => {
          this.updateViewDate();
        }, 1500); // 1.5秒
      }
      this.notifications.addClass('is-active');
      this.$emit('open');
    },
    close: function(){
      this.notifications.removeClass('is-active');
    },
    convertMarkdownToHtml(markdown) {
      return new MarkdownIt().render(markdown);
    },
  }
};
</script>

<style>
.notification-badge {
  width: 12px;
  height: 12px;
  line-height: 12px;
  background-color: red;
  border-radius: 50%;
  color: #fff;
  opacity: 1.0;
  text-align: center;
  position: absolute;
  top: 17px;
  right: 18px;
  z-index: 100;
  animation: flash 1s linear infinite alternate;
}
.add-poiner:hover {
    cursor: pointer;
}

@keyframes flash {
    0%{
        opacity: 0.8;
    }
    100%{
        opacity: 1.0;
    }
}
</style>
